var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.46 2C20.69 2.35 19.86 2.58 19 2.69C19.88 2.16 20.56 1.32 20.88 0.31C20.05 0.81 19.13 1.16 18.16 1.36C17.37 0.5 16.26 0 15 0C12.65 0 10.73 1.92 10.73 4.29C10.73 4.63 10.77 4.96 10.84 5.27C7.27999 5.09 4.10999 3.38 1.99999 0.79C1.62999 1.42 1.41999 2.16 1.41999 2.94C1.41999 4.43 2.16999 5.75 3.32999 6.5C2.61999 6.5 1.95999 6.3 1.37999 6V6.03C1.37999 8.11 2.85999 9.85 4.81999 10.24C4.19072 10.4122 3.53009 10.4362 2.88999 10.31C3.1616 11.1625 3.69353 11.9084 4.41101 12.4429C5.12849 12.9775 5.99544 13.2737 6.88999 13.29C5.37362 14.4904 3.49399 15.1393 1.55999 15.13C1.21999 15.13 0.879993 15.11 0.539993 15.07C2.43999 16.29 4.69999 17 7.11999 17C15 17 19.33 10.46 19.33 4.79C19.33 4.6 19.33 4.42 19.32 4.23C20.16 3.63 20.88 2.87 21.46 2Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.3a464932c47c4245fe4dda1c427c9e84.svg";
export { ForwardRef as ReactComponent };